"use client"

import { ProductPrice } from "~/components/ui/Product/ProductHeader/ProductDetails/ProductPrice"
import type { ProductPriceWithVariantSwitchProps } from "~/app/[locale]/products/[slug]/_components/ProductPriceWithVariantSwitch"
import { useVariantSwitch } from "~/app/[locale]/products/[slug]/_hooks/use-variant-switch"

function ClientProductPriceWithVariantSwitch({ productHeader }: ProductPriceWithVariantSwitchProps) {
  const { currentProductMultipleOptions } = useVariantSwitch({
    defaultSize: productHeader.defaultOptions?.size,
    ...(productHeader.defaultOptions?.confort ? { defaultConfort: productHeader.defaultOptions?.confort } : {}),
  })

  return <ProductPrice productHeader={productHeader} currentMultipleOptions={currentProductMultipleOptions} />
}

export default ClientProductPriceWithVariantSwitch
